import React from 'react';
import AiDisclaimer from './AiDisclaimer';

/**
 * Two-column Start / Sit recommendation panel for S1 use case.
 *
 * @param {Object}   props
 * @param {Array}    props.starts     - Array of RosterSlotAdvice (start these)
 * @param {Array}    props.sits       - Array of RosterSlotAdvice (sit these)
 * @param {string}   props.dataAsOf   - ISO timestamp for AiDisclaimer
 * @param {Function} [props.onClose]  - Optional close handler
 */
export default function StartSitPanel({ starts, sits, dataAsOf, onClose }) {
  return (
    <div className="start-sit-panel">
      <div className="ai-suggestion-panel-header">
        <span className="ai-suggestion-panel-title">✦ Start / Sit Recommendations</span>
        {onClose && (
          <button className="ai-suggestion-panel-close" onClick={onClose} aria-label="Close">
            ✕
          </button>
        )}
      </div>

      <p className="ai-context-note">Factors in recent form and player news.</p>

      <div className="start-sit-columns">
        <div className="start-sit-column">
          <h4 className="start-sit-column-heading start">▲ Start</h4>
          <ul className="start-sit-list">
            {starts.map((p, i) => (
              <li key={i} className="start-sit-card">
                <span className="start-sit-player">{p.playerName}</span>
                <span className="start-sit-meta">{p.position} · {p.slot}</span>
                {p.reason && <p className="start-sit-reason">{p.reason}</p>}
              </li>
            ))}
          </ul>
        </div>

        <div className="start-sit-column">
          <h4 className="start-sit-column-heading sit">▼ Sit</h4>
          <ul className="start-sit-list">
            {sits.map((p, i) => (
              <li key={i} className="start-sit-card">
                <span className="start-sit-player">{p.playerName}</span>
                <span className="start-sit-meta">{p.position} · {p.slot}</span>
                {p.reason && <p className="start-sit-reason">{p.reason}</p>}
              </li>
            ))}
          </ul>
        </div>
      </div>

      <AiDisclaimer
        dataAsOf={dataAsOf}
        earlyAccess="Start/Sit is in early access. Recommendations weigh schedule strength, defensive rankings, recent weekly production, and recent player news."
      />
    </div>
  );
}
